import { render, staticRenderFns } from "./Audits.vue?vue&type=template&id=07ef0644&scoped=true"
import script from "./Audits.vue?vue&type=script&lang=js"
export * from "./Audits.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07ef0644",
  null
  
)

export default component.exports